import {TargetGroup} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/target_group.types';
import {useSelectedTargetGroup} from '../../../shared-deprecated/useSelectedTargetGroup';
import {useSelectedDiscount} from './useSelectedDiscount';

export function useSelectedDiscountColor(): string | undefined;

export function useSelectedDiscountColor() {
  const selectedDiscount = useSelectedDiscount();
  const {targetGroup} = useSelectedTargetGroup();

  if (!selectedDiscount) {
    return;
  }

  if (targetGroup === TargetGroup.MALE) {
    return selectedDiscount.femaleTopBanner.backgroundColor;
  } else {
    return selectedDiscount.maleTopBanner.backgroundColor;
  }
}
